export const heartbeatFrequency = 10; //seconds
